import React, { useContext, useState, useEffect, useRef } from "react";
import Logo from "../CourseImages/Logo.png";
import styles from "./TeacherNav.module.css";
import { Link, useLocation } from "react-router-dom";
import scalendar from "../../assets/scalendar.png";
import seditprofile from "../../assets/seditprofile.png";
import slogout from "../../assets/slogout.png";
import shome from "../../assets/homeicon.png";
import { UserContext } from "../UserContext";

const TeacherNav = ({ onLogout }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { logout } = useContext(UserContext);

  const isCoursePage = currentPath.includes('/StudentDashboard/') || 
                      currentPath.includes('/GradeProjectPage/') || 
                      currentPath.includes('/TakeClass/') || 
                      currentPath.includes('/admin_manage_classes/') ||
                      currentPath === '/TeacherCourses';
  
  const [openDropdowns, setOpenDropdowns] = useState({});
  const dropdownRefs = useRef({});

  useEffect(() => {
    const handleClickOutside = (event) => {
      Object.keys(openDropdowns).forEach(dropdownKey => {
        const dropdownRef = dropdownRefs.current[dropdownKey];
        if (dropdownRef && !dropdownRef.contains(event.target)) {
          setOpenDropdowns(prev => ({
            ...prev,
            [dropdownKey]: false
          }));
        }
      });
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openDropdowns]);

  const toggleDropdown = (dropdownKey) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdownKey]: !prev[dropdownKey]
    }));
  };

  const closeDropdown = (dropdownKey) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [dropdownKey]: false
    }));
  };
  return (
    <>
      {/* Sidebar for large screens */}
      <div className={styles.teacherNavSidebar}>
        <img src={Logo} alt="Logo" className={styles.teacherNavLogo} />
        {/* {currentPath === "/calenderview" && (
          <div className="calendar-heading">Calender</div>
        )} */}
        <div className={styles.teacherNavMenu}>
          <Link
            to="/"
            className={`${styles.teacherNavItem}${
              currentPath === "/" ? ` ${styles.active}` : ""
            }`}
          >
            <img src={shome} alt="Home" className={styles.teacherNavIcon} />
            <span className={styles.teacherNavText}>Home</span>
          </Link>
          <Link
            to="/TeacherCourses"
            className={`${styles.teacherNavItem}${
              isCoursePage ? ` ${styles.active}` : ""
            }`}
          >
            <img
              src={scalendar}
              alt="Courses"
              className={styles.teacherNavIcon}
            />
            <span className={styles.teacherNavText}>Courses</span>
          </Link>
          <Link
            to="/calenderview"
            className={`${styles.teacherNavItem}${
              currentPath === "/calenderview" ? ` ${styles.active}` : ""
            }`}
          >
            <img
              src={scalendar}
              alt="Calendar"
              className={styles.teacherNavIcon}
            />
            <span className={styles.teacherNavText}>Calendar</span>
          </Link>
          <Link
            to="/EditProfile"
            className={`${styles.teacherNavItem}${
              currentPath === "/EditProfile" ? ` ${styles.active}` : ""
            }`}
          >
            <img
              src={seditprofile}
              alt="Edit Profile"
              className={styles.teacherNavIcon}
            />
            <span className={styles.teacherNavText}>Profile</span>
          </Link>
        </div>
        <div className={styles.teacherNavLogout}>
          <button
            className={`${styles.teacherNavItem} ${styles.logoutBtn}`}
            onClick={() => {
              console.log("Logout button clicked");
              if (onLogout) {
                onLogout(); // Use prop if provided (for backward compatibility)
              } else {
                logout(); // Use centralized logout function
              }
            }}
          >
            <img
              src={slogout}
              alt="Log Out"
              className={styles.teacherNavIcon}
            />
            <span className={styles.teacherNavText}>Log Out</span>
          </button>
        </div>
      </div>
      {/* Bottom nav for small screens */}
      <div className={styles.teacherNavBottomnav}>
        <Link
          to="/"
          className={`${styles.teacherNavBottomnavItem}${
            currentPath === "/" ? ` ${styles.active}` : ""
          }`}
        >
          <img
            src={shome}
            alt="Home"
            className={styles.teacherNavBottomnavIcon}
          />
          <span>Home</span>
        </Link>
        <Link
          to="/TeacherCourses"
          className={`${styles.teacherNavBottomnavItem}${
            isCoursePage ? ` ${styles.active}` : ""
          }`}
        >
          <img
            src={scalendar}
            alt="Courses"
            className={styles.teacherNavBottomnavIcon}
          />
          <span>Courses</span>
        </Link>
        <Link
          to="/calenderview"
          className={`${styles.teacherNavBottomnavItem}${
            currentPath === "/calenderview" ? ` ${styles.active}` : ""
          }`}
        >
          <img
            src={scalendar}
            alt="Calendar"
            className={styles.teacherNavBottomnavIcon}
          />
          <span>Calendar</span>
        </Link>
        <Link
          to="/EditProfile"
          className={`${styles.teacherNavBottomnavItem}${
            currentPath === "/EditProfile" ? ` ${styles.active}` : ""
          }`}
        >
          <img
            src={seditprofile}
            alt="Profile"
            className={styles.teacherNavBottomnavIcon}
          />
          <span>Profile</span>
        </Link>
        <Link
          className={`${styles.teacherNavBottomnavItem}`}
          onClick={() => {
            if (onLogout) {
              onLogout(); // Use prop if provided (for backward compatibility)
            } else {
              logout(); // Use centralized logout function
            }
          }}
        >
          <img
            src={slogout}
            alt="Log Out"
            className={styles.teacherNavBottomnavIcon}
          />
          <span>Log Out</span>
        </Link>
      </div>
    </>
  );
};

export default TeacherNav;
